/* Counts a returned, accepted artwork inquiry. Never reads contact details. */
(function () {
  'use strict';
  const root = document.querySelector('[data-rw-inquiry-product]');
  if (!root || root.dataset.rwInquiryBound) return;
  const form = root.querySelector('form');
  if (!form) return;
  root.dataset.rwInquiryBound = 'true';
  const productId = root.dataset.rwInquiryProduct;
  const key = 'rw.inquiry.pending.v1.' + productId;
  const ttl = 30 * 60 * 1000;
  const types = ['purchase_consultation', 'availability_or_details'];
  const permitted = () => {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  };
  const clear = () => { try { window.sessionStorage.removeItem(key); } catch (_) {} };
  const read = () => {
    try { return JSON.parse(window.sessionStorage.getItem(key)); }
    catch (_) { return null; }
  };
  const valid = p => p && p.product_id === productId && p.path === location.pathname &&
    p.form_id === form.id && typeof p.request_id === 'string' &&
    /^[0-9a-f-]{36}$/.test(p.request_id) && types.includes(p.inquiry_type) &&
    Number.isFinite(p.created_at) && Date.now() >= p.created_at && Date.now() - p.created_at <= ttl;

  // A submit event alone is never a lead, including a captcha-delayed submission.
  form.addEventListener('submit', () => {
    if (!permitted() || !form.checkValidity()) { clear(); return; }
    try {
      const inquiryType = form.elements.namedItem('contact[inquiry_type]').value;
      if (!types.includes(inquiryType)) { clear(); return; }
      const existing = read();
      const pending = {
        product_id: productId, path: location.pathname, form_id: form.id,
        request_id: valid(existing) ? existing.request_id : window.crypto.randomUUID(),
        inquiry_type: inquiryType, created_at: Date.now(),
        is_test: new URL(location.href).searchParams.get('rw_inquiry_test') === '1'
      };
      window.sessionStorage.setItem(key, JSON.stringify(pending));
    } catch (_) { clear(); }
  }, true);

  const success = root.querySelector('[data-rw-inquiry-accepted]');
  const error = root.querySelector('[data-rw-inquiry-error]');
  let finished = false;
  let attempts = 0;
  const finish = () => {
    if (finished) return;
    if (error || !success) { clear(); finished = true; return; }
    const p = read();
    const url = new URL(location.href);
    if (!valid(p) || url.searchParams.get('contact_posted') !== 'true' ||
        url.hash !== '#' + form.id) { clear(); finished = true; return; }
    if (window.Shopify && window.Shopify.designMode) {
      clear(); finished = true; return;
    }
    if (!permitted() || typeof window.gtag !== 'function') {
      if (++attempts < 20) window.setTimeout(finish, 250);
      else { clear(); finished = true; }
      return;
    }
    // Consume before publishing: uncertain delivery must not cause a duplicate retry.
    clear();
    finished = true;
    try {
      window.gtag('event', p.is_test ? 'rw_inquiry_validation' : 'generate_lead', {
        send_to: 'G-6HK2MLWV49', schema_version: 1, request_id: p.request_id,
        product_id: p.product_id, inquiry_type: p.inquiry_type,
        page_location: location.origin + p.path,
        ...(p.is_test ? {debug_mode: true} : {})
      });
    } catch (_) {}
  };
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finish);
    } catch (_) { finish(); }
  }
  finish();
})();
